shadow$provide[413] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `varying float vPixelSize;

float getDiscHollowAlpha(float mask) {
  return vPixelSize * (0.5 - 2.0 * abs(sqrt(mask) - .75));
}
`;

};